import { useFormikContext } from "formik";
import { useEffect } from "react";
import { AdvicePriceFormValues } from "../../AdviceCards/interfaces";

export const useResetAdviceDiffConsentIfChangesInForm = (): void => {
  const { values, setFieldValue } = useFormikContext<AdvicePriceFormValues>();
  const {
    disabilityCheckedToPurchase,
    disabilityInsuredSumValue,
    disabilityOneTimePayment,
    deathCheckedToPurchase,
    deathInsuredSumValue,
    criticalIllnessCheckedToPurchase,
    criticalIllnessInsuredSumValue,
  } = values;

  useEffect(() => {
    setFieldValue("adviceDiffConsent", false);
  }, [
    disabilityCheckedToPurchase,
    disabilityInsuredSumValue,
    disabilityOneTimePayment,
    deathCheckedToPurchase,
    deathInsuredSumValue,
    criticalIllnessCheckedToPurchase,
    criticalIllnessInsuredSumValue,
  ]);
};
